var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AsyncButton',_vm._b({attrs:{"icon":"icon-copy","show-label":_vm.showLabel,"action-label":"Copy","waiting-label":"Copying...","success-label":"Copied!","error-label":"Error Copying","delay":2000},on:{"click":_vm.clicked}},'AsyncButton',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }